import styled, { css } from 'styled-components'
import {
  TableBodyProps,
  TableCellProps,
  TableHeadProps,
  TableHeaderCellProps,
  TablePaginationButtonProps,
  TableRowProps,
} from './types'
import Flex from 'src/components/Layout/Flex/Flex'
import { ScrollBarStyles } from 'src/components/Core/Styles/general-utilities'

export const TableContainer = styled('table') <{ tableReadOnly?: boolean, tableLayout?: string; }>`
  width: 100%;
  outline: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-radius: 4px 4px 0px 0px;
  border-spacing: 0px;
  color: ${props => props.theme.colors.main.dark};
  margin-top: 12px;
  margin-bottom: 16px;

  ${props => props.tableReadOnly && css`
    background-color: ${props => props.theme.colors.shades.neutral[0]};
    pointer-events: none;
    cursor: not-allowed;

    path {
      fill: ${props => props.theme.colors.shades.neutral[5]};
    }
  `}

  ${props => props.tableLayout && css`
    table-layout: ${props.tableLayout};
  `}
`

export const TableHeaderCell = styled('th')<TableHeaderCellProps>`
  padding: 12px;
  background-color: ${props => props.theme.colors.shades.neutral[1]};
  text-align: left;
  max-width: ${props => props.maxWidth || '300px'};
  :first-child {
    border-radius: 4px 0px 0px 0px;
  }
  :last-child {
    border-radius: 0px 4px 0px 0px;
  }

  p:has(svg){ 
    align-items: center;  
  }

  ${props => props.version === 2 &&
    css`
      padding: 20px 12px;
      background-color: ${props.theme.colors.shades.neutral[0]};
      border-bottom: 1px solid ${props.theme.colors.shades.neutral[1]};
    `}

    ${props => props.width &&
      css`
        width: ${props.width};
      `}
`

export const TableCell = styled('td')<TableCellProps>`
  padding: ${props => props.tableCellPadding || '12px'};
  border-bottom: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  max-width: ${props => props.maxWidth || '300px'};
  ${props =>
    props.iconCell &&
    css`
      width: 20px;
    `}
  ${props => props.fixedColumnsWidth && css`
    &:last-of-type {
      text-align: right;
    }
  `}
`

export const TableRow = styled('tr')<TableRowProps>`
  :last-child {
    td {
      border-bottom: 0;
    }
  }

  ${props => props.selected &&
    css`
      background-color: ${props => props.theme.colors.shades.neutral[0]};
    `}

  ${props => props.addScrollToTableBody &&
    css`
      display: table;
      width: 100%;
      table-layout: fixed;
    `}

  ${props => props.lastGrey &&
    css`
      background-color: ${props => props.theme.colors.shades.neutral[0]};
    `}

  ${props => props.height &&
    css`
      height: ${props.height};
    `}
`

export const TableRowToModal = styled('tr')`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  td {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const PaginationButton = styled('button')<TablePaginationButtonProps>`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  color: ${props => props.theme.colors.main.dark};
  background-color: ${props => props.theme.colors.main.background};
  cursor: pointer;


  &:disabled {
    color: ${props => props.theme.colors.shades.neutral[1]};
    cursor: initial;
  }

  ${props => props.active && css`
    color: ${props => props.theme.colors.main.blank};
    background-color: ${props => props.theme.colors.main.ultraViolet};

    &:disabled {
      color: ${props => props.theme.colors.main.blank};
      background-color: ${props => props.theme.colors.main.ultraViolet};
      opacity: 0.5;
      cursor: initial;
    }

  `}
`

export const IconWrapper = styled(Flex)`
  justify-content: left;
`

export const TableBody = styled('tbody')<TableBodyProps>`
  ${props =>
    props.addScrollToTableBody &&
    css`
      display: block;
      height: 500px;
      overflow-y: auto;
      overflow-x: hidden;
    `}

   ${ScrollBarStyles}
`

export const TableHead = styled('thead')<TableHeadProps>`
  ${props =>
    props.addScrollToTableBody &&
    css`
      display: table;
      width: 100%;
      table-layout: fixed;
    `}

  ${props => props.fixedColumnsWidth && css`
    th {
      width: 40%;
    }

    th:last-of-type {
      width: 20%;
    }
  `}
`
